import { Box, Skeleton, Stack } from '@mui/material';

import { doInit2factorAuth, useCosInfo } from '@/controllers/gridManager/accountsManager/accountManager';
import { getCopierInfo } from '@/controllers/gridManager/followerTransManager/followerTransManager';
import classNames from 'classnames/bind';
import { DataOnParents, KeyDataParents } from '../RegisterFollower/RegisterFollower';
import styles from './Step1.scss';

import { STATUS_ACCOUNT } from '@/stores/dataStore/memoryStore/const/constIndex';
import ButtonElement from '@/views/elements/button/ButtonElement';
import TypographyElement from '@/views/elements/typography/TypographyElement';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { setStateLoadingAction } from '@/stores/dataManager/Actions/appAction';
const cx = classNames.bind(styles);

export type PropsStep = {
    close: () => void,
    back: () => void,
    next: () => void,
    handleSaveDataOnParents: (key: KeyDataParents, data: {}) => void
    dataOnParents: DataOnParents,
    data: any
}

export type RadioStopCopy = "TRANS" | "SELL"


const Step1 = ({ close, back, next, handleSaveDataOnParents, dataOnParents, data }: PropsStep) => {
    const { t } = useTranslation()

    const { cosInfo } = useCosInfo()
    const { refaccount } = cosInfo
    const [isHasStocks, setIsHasStocks] = useState<boolean>(true)
    const [loading, setLoading] = useState<boolean>(true)


    useEffect(() => {
        async function callApiCopierInfo(accountId: string) {
            const { isSuccess, data } = await getCopierInfo({
                accountId: accountId
                , masterAccount: '' // get all
            })
            setLoading(false)
            if (isSuccess) {
                const rsFind = data.find((item: any) => (item.status === STATUS_ACCOUNT.WC || item.status === STATUS_ACCOUNT.A))
                if (rsFind) {
                    setIsHasStocks(true)
                } else {
                    setIsHasStocks(false)
                }
            }
        }

        setLoading(true)
        if (refaccount) {
            callApiCopierInfo(refaccount)
        }
    }, [refaccount])


    const handleNext = async () => {
        setStateLoadingAction(true)
        const { isSuccess, data } = await doInit2factorAuth()
        setStateLoadingAction(false)
        if (isSuccess && Object.hasOwn(data, 'transactionId')) {
            handleSaveDataOnParents("Step1", { isHasStocks, loading });
            handleSaveDataOnParents("dataVerify", data);
            next()
        }
    }

    return (
        <Box className="Step1" sx={{ height: "auto", overflow: 'auto' }}>
            <Stack
                direction={"column"}
                spacing={2}
            >
                <TypographyElement ColorElement="secondary" FontWeightElement={400} FontSizeElement='16px'>
                    {loading &&
                        <>
                            <Skeleton variant="text" sx={{ fontSize: '20px' }} />
                            <Skeleton variant="text" sx={{ fontSize: '20px' }} />
                        </>}
                    {loading === false && (isHasStocks === true ? t("copytrade.deleteFollower.warnHasStocks") :
                        t("copytrade.deleteFollower.warn")
                    )}
                </TypographyElement>

                <Stack
                    direction={"row"}
                    spacing={2}
                    justifyContent={"center"}
                >
                    <ButtonElement customType="Secondary" className={cx("btn-register")} variant="contained"
                        onClick={() => close()} > {t("copytrade.common.back")}</ButtonElement>
                    <ButtonElement customType="Primary" className={cx("btn-register")} variant="contained"
                        onClick={
                            () => handleNext()
                        } >{t("copytrade.common.confirm")}</ButtonElement>
                </Stack>
            </Stack>
        </Box >
    )
}

export default Step1